import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  hdng: {
    fontFamily: "Inter",
    fontSize: 24,
    fontWeight: 700,
    color: "#000",
    marginBottom: 15,
    marginTop: 12
  },
  activeSubCard: {
    borderRadius: 20,
    padding: "12px 10px 25px 10px",
    backgroundColor: "#FFF",
    border: "2px solid #E5E5E5",
  },
  cardHdng: {
    fontFamily: "Inter",
    fontSize: 24,
    fontWeight: 700,
    color: "#000",
    padding: "3px 10px 15px 10px",
    borderBottom: "1px solid #D4D4D4",
    margin: 0,
  },
  infoWrapper: {
    flexDirection: "column",
    gap: 10,
    marginTop: 20,
    paddingInline: 10
  },
  label: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 700,
    color: "#000",
  },
  labelValueWrapper: {
    gap: 5,
    alignItems: "center",
  },
  value: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 400,
    color: "#000",
  },
  subStatus: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 500,
    color: "#027A48",
    padding: "3px 12px",
    borderRadius: 16,
    backgroundColor: "#ECFDF3",
  },
  inactiveSubStatus: {
    backgroundColor: "#FEE4E2",
    color: "#F04438",
  },
}));

export default useStyles;
